module.exports = __webpack_public_path__ + "assets/img/s2_tab1_m.5fa8f9ad.png";